import { Component, Inject, OnInit } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { CommonService } from "@services/common.service";
import { CanvasService } from "@services/canvas.service";

@Component({
    selector: "app-create",
    templateUrl: "./create.component.html",
    styleUrls: ["./create.component.scss"],
    standalone: false
})
export class CreateDialogComponent implements OnInit {
  public categories: any;

  public createForm!: UntypedFormGroup;
  public canvasType: any;
  constructor(
    private fb: UntypedFormBuilder,
    private commonService: CommonService,
    private canvasService: CanvasService,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<CreateDialogComponent>,
    public dialog: MatDialog,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data) {
      this.title = data.title;
      this.module_id = data.module_id;
      this.canvas_id = data.canvas_id;
      this.description = data.description;
      this.canvasType = data.canvasType;
      this.actionButton = data.actionButton;
      this.showMessage = data.showMessage;
    }
  }

  title!: string;
  module_id!: string;
  description!: string;
  canvas_id!: string;
  actionButton: string = "create";
  showMessage?: boolean = false;
  assignedGroups: string = "";
  securityGroups: any = [];
  userGroupId: any;
  showCategory: boolean = false;

  onNoClick(): void {
    this.dialogRef.close();
  }

  createReport() {
    const blankFields = this.getBlankRequiredFieldLabels();
    if (blankFields.length) {
      this.createForm.markAllAsTouched();
      this._openSnackBar(this.buildBlankFieldsMessage(blankFields), false);
      return;
    }

    let securityGroups: any[] = [];
    securityGroups = this.commonService.formatSecurityGroups(
      this.securityGroups,
      false
    );

    let formBody: any = {};
    if (this.canvas_id) {
      formBody = {
        name: this.createForm.controls["title"].value,
        category_id: this.createForm.controls["module_id"].value,
        description: this.createForm.controls["description"].value,
        canvasGroups: securityGroups,
        [this.canvasType + "_id"]: this.canvas_id,
      };
    } else {
      formBody = {
        name: this.createForm.controls["title"].value,
        category_id: this.createForm.controls["module_id"].value,
        description: this.createForm.controls["description"].value,
        canvasGroups: securityGroups,
      };
    }
    if (this.createForm.valid) {
      if (this.canvas_id) {
        if (this.actionButton == "export") {
          formBody.report_id = this.canvas_id;
          this.canvasService.exportReportToDashboard(formBody);
        } else {
          this.canvasService.setType(this.canvasType + 's');
          this.canvasService.duplicateReport(formBody);
        }
      } else {
        this.canvasService.createReport(formBody);
      }

      this.dialogRef.close();
    } else {
      this.createForm.markAllAsTouched();
    }
  }

  private getBlankRequiredFieldLabels(): string[] {
    const blankFields: string[] = [];
    const title = this.createForm.controls["title"].value;
    const description = this.createForm.controls["description"].value;

    if (!title || !title.trim()) {
      blankFields.push("Title");
    }
    if (!description || !description.trim()) {
      blankFields.push("Description");
    }

    return blankFields;
  }

  private buildBlankFieldsMessage(blankFields: string[]): string {
    const canvasTypeLabel =
      this.canvasType.charAt(0).toUpperCase() + this.canvasType.slice(1);
    const fieldList = blankFields.join(" and ");
    const verb = blankFields.length > 1 ? "are" : "is";

    return `${canvasTypeLabel} ${fieldList} ${verb} required and cannot be blank. Please enter a valid value to continue.`;
  }

  private _openSnackBar(message: string, success: boolean) {
    const successClass = success ? "canvas-snackbar" : "canvas-snackbar-error";
    this.snackBar.open(message, "", {
      duration: 5000,
      panelClass: [successClass],
    });
  }

  getCategories() {
    this.categories = JSON.parse(sessionStorage.getItem("userCategoryListing"));
    if (this.categories) {
      if (this.categories.length > 1) {
        this.showCategory = true;
      } else {
        this.createForm.controls["module_id"].setValue(this.categories[0].id);
        this.showCategory = false;
      }
    }
  }
  getAllSecurityGroups() {
    this.commonService.getAllSecurityGroups().subscribe((data: any) => {
      this.securityGroups = data.data;
      const userGroup = this.securityGroups.filter((element: any) => {
        return element.id == this.userGroupId;
      });

      this.securityGroups.forEach((element: any) => {
        element.edit = element.edit ? true : false;
        element.view = element.view ? true : false;
      });
    });
  }

  ngOnInit(): void {
    this.createForm = this.fb.group({
      module_id: new UntypedFormControl(this.module_id || 1, [
        Validators.required,
      ]),
      title: new UntypedFormControl(this.title, [Validators.required]),
      description: new UntypedFormControl(this.description, [
        Validators.required,
      ]),
    });
    this.getCategories();
    this.getAllSecurityGroups();
  }
}
